<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="my-3 mx-2 p-3 border rounded bg-white">
      <h3>Activity Log</h3>

      <b-row class="mt-2">
        <b-col class="col-4 p-1" lg="3" md="4">
          <b-form-group class="ms-2">
            <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                           class="col-md-4" size="sm" @change="handlePageSizeChange"></b-form-select>
          </b-form-group>
        </b-col>
        <!-- search  -->
        <b-col>
          <div class="d-flex flex-row d-flex justify-content-end">
            <b-form-input v-model="filter" class="me-2" placeholder="Type to filter data" style="width: 30%;"
                          type="search"></b-form-input>
            <button class="rounded btn-info me-4" @click="onSearch">Search</button>
          </div>
        </b-col>
      </b-row>
      <b-table :busy="isLoading" :fields="fields" :items="allActivities" :per-page="perPage" bordered hover striped>
        <template #cell(activity_type)="row">
          <div class="px-2">
            <div :style="{'background-color': activityTypeColor(row.item.activity_type)}" class="badge text-capitalize">
              {{ row.item.activity_type }}
            </div>
          </div>
        </template>
        <template #cell(content_type)="row">
          <div class="px-2">
            <div class=" text-capitalize">
              {{ getContentType(row.item.content_type, row.item.subcategory_name) }}
            </div>
          </div>
        </template>
        <template #cell(update_date)="row">
          {{ format_datetime(row.item.update_date) }}
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2 px-2">
            <b-spinner class="align-middle mx-2"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <!-- Pagination -->
      <b-row>
        <b-col class="mt-2" md="12" sm="12">
          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="center"
                        class="my-0" next-text="Next" prev-text="Prev"
                        @click="handlePageChange"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/services/activity-service";
import {notify} from "@kyvg/vue3-notification";
import {format_datetime} from "../helpers";

export default {
  data() {
    return {
      isLoading: false,
      allActivities: [],
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 100],
      filter: null,
      fields: [
        {
          label: 'Content Details', key: 'content_title', sortable: true, thStyle: {width: "25%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'content_type', sortable: false,
          class: 'text-center', thStyle: {width: "10%"},
          filterByFormatted: true
        },
        {
          label: 'Details', key: 'message', sortable: true, thStyle: {width: "25%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Time', key: 'update_date', sortable: false, thStyle: {width: "15%"},
          class: 'text-center',
          filterByFormatted: true
        },
        {
          label: 'Updated By', key: 'update_by_name', sortable: false,
          class: 'text-center', thStyle: {width: "15%"},
          filterByFormatted: true
        },
        {
          label: 'User IP', key: 'user_ip', sortable: false,
          class: 'text-center', thStyle: {width: "15%"},
          filterByFormatted: true
        },
        {
          key: 'activity_type', sortable: false,
          class: 'text-center', thStyle: {width: "10%"},
          filterByFormatted: true
        },
      ],
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Activity Log',
          href: '#',
        },
      ],
    };
  },
  watch: {
    filter(data) {
      this.onSearch();
      return data;
    }
  },
  async created() {
    await this.fetchActivities();
  },
  methods: {
    format_datetime,
    activityTypeColor(type) {
      switch (type) {
        case "insert":
          return "green";
        case "update":
          return "blue";
        case "trash":
          return "orange";
        case "delete":
          return "red";
        default:
          return "blue";
      }
    },
    getContentType(type, categoryName) {
      switch (type) {
        case "element":
          return categoryName;
        case "subcategory":
          return categoryName + " category";
        default:
          return type;
      }
    },
    onSearch() {
      if (this.filter != null && this.filter !== "") {
        this.fetchActivities();
      } else {
        this.fetchActivities();
      }
    },
    async handlePageChange() {
      await this.fetchActivities();
    },
    handlePageSizeChange(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.fetchActivities();
    },
    async fetchActivities() {
      let params = {}
      if (this.filter != null && this.filter !== "") {
        params = {
          'per_page': this.perPage,
          'page': this.currentPage,
          'search': this.filter
        };
      } else {
        params = {
          'per_page': this.perPage,
          'page': this.currentPage,
          'search': null
        };
      }
      try {
        this.isLoading = true;
        const response = await ActivityService.getPaginatedActivityLogs(params)
        this.isLoading = false;
        if (response) {
          if (response.status) {
            this.totalRows = response.data.total
            console.log("this.totalRows", this.totalRows)
            this.allActivities = response.data.data;
          } else {
            notify({
              type: "error",
              title: "Error fetching notifications",
              text: response.message,
            });
          }
        }
      } catch (e) {
        this.isLoading = false;
        console.log(e)
      }
    }
  },
};
</script>
